import { render, staticRenderFns } from "./ReportPhotosWidget.vue?vue&type=template&id=196876a9&"
import script from "./ReportPhotosWidget.vue?vue&type=script&lang=js&"
export * from "./ReportPhotosWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhotosWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196876a9')) {
      api.createRecord('196876a9', component.options)
    } else {
      api.reload('196876a9', component.options)
    }
    module.hot.accept("./ReportPhotosWidget.vue?vue&type=template&id=196876a9&", function () {
      api.rerender('196876a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportPhotosWidget.vue"
export default component.exports